import React from 'react'
import ModalTransition from './ModalTransition'
import { useModalContext } from './ModalContext'

const ModalRoot: React.FC = () => {
  const {
    component: Component,
    props,
    hideModal,
    isModalOpen,
  } = useModalContext()

  return (
    <div data-testid="modal-root">
      <ModalTransition show={isModalOpen}>
        {() =>
          Component ? (
            <Component
              // deprecated, use hideModal
              onCancel={hideModal as never}
              hideModal={hideModal}
              isModalOpen={isModalOpen}
              {...props}
            />
          ) : null
        }
      </ModalTransition>
    </div>
  )
}

export default ModalRoot
